import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = rad/s. */
export const ANGULAR_VELOCITY_PIVOT: Record<string, number> = {
  'rad/s': 1,
  rps: 2 * Math.PI,
};

export const transformAngularVelocity = createPivotTransformer(ANGULAR_VELOCITY_PIVOT);
